import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Team from "./pages/Team";
import ScrollToTop from "./components/ScrollToTop";
import "./styles/main.css";
import ContactForm from "./components/ContactForm";
import AboutUs from "./pages/AboutUs";
import ServiceDetails from "./components/ServiceDetails";
import AdminDashboard from "./components/AdminDashboard";
import { supabase } from "./utils/supabaseClient";
import SignIn from "./pages/SignIn";
import ServiceList from "./components/ServiceList";
import Offers from "./pages/Offers";

// PrivateRoute component
function PrivateRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const checkSession = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      setAuthenticated(!!session);
      setLoading(false);
    };
    checkSession();
  }, []);

  if (loading) return <p>Loading...</p>;
  return authenticated ? children : <Navigate to="/signin" replace />;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/offers" element={<Offers />} />
        <Route path="/team" element={<Team />} />
        <Route path="/contactform" element={<ContactForm />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/serviceList" element={<ServiceList />} />
        <Route path="/services/:id" element={<ServiceDetails />} />
        <Route path="/signin" element={<SignIn />} />
        <Route
          path="/admindashboard"
          element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/admindashboard"
          element={<Navigate to="/signin" replace />}
        />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
